<h1 mat-dialog-title>{{ 'Task' | translate }}</h1>
<div mat-dialog-content>
  <mat-form-field>
    <mat-label>{{ 'Task name' | translate }}</mat-label>
    <input matInput [(ngModel)]="data.taskName">
  </mat-form-field>
</div>
<div mat-dialog-actions class="actions">
  <button mat-stroked-button (click)="onNoClick()">{{ 'Cancel' | translate }}</button>
  <div>
    <button *ngIf="!data.isNew" mat-flat-button color="warn" (click)="remove()">{{ 'Remove' | translate }}</button>
    <button mat-flat-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>{{ 'Save' | translate }}</button>
  </div>
</div>
